/**
 * HDRPhoto commercial analytics events. Apps should emit these through
 * `trackHdrEvent` rather than inventing local names.
 */

export const HDR_ANALYTICS_EVENTS = [
  'hdr_pricing_viewed',
  'hdr_pricing_slider_changed',
  'hdr_plan_selected',
  'hdr_checkout_started',
  'hdr_subscription_started',
  'hdr_subscription_upgraded',
  'hdr_subscription_downgraded',
  'hdr_subscription_cancelled',
  'hdr_image_uploaded',
  'hdr_image_processed',
  'hdr_image_downloaded',
  'hdr_allowance_low',
  'hdr_rehub_cross_sell_clicked',
] as const;

export type HdrAnalyticsEvent = (typeof HDR_ANALYTICS_EVENTS)[number];

export interface HdrAnalyticsProps {
  plan?: string | null;
  allowance?: number | null;
  currency?: 'GBP' | 'EUR' | 'USD' | null;
  price?: number | null;
  remaining?: number | null;
  destination?: string | null;
  [key: string]: string | number | boolean | null | undefined;
}

export function trackHdrEvent(
  event: HdrAnalyticsEvent | string,
  props?: HdrAnalyticsProps,
): void {
  if (typeof window === 'undefined') return;
  const gtag = (window as Window & { gtag?: (...args: unknown[]) => void }).gtag;
  if (typeof gtag === 'function') {
    gtag('event', event, props);
  }
  const fbq = (window as Window & { fbq?: (...args: unknown[]) => void; __rehubTracking?: { meta?: string } }).fbq;
  const sharedPixel = (window as Window & { __rehubTracking?: { meta?: string } }).__rehubTracking?.meta;
  if (sharedPixel) return;
  if (typeof fbq === 'function' && event === 'hdr_checkout_started') {
    fbq('track', 'InitiateCheckout', props);
  }
  if (typeof fbq === 'function' && event === 'hdr_subscription_started') {
    fbq('track', 'Subscribe', props);
  }
}
